import { device } from '../utils/responsive_utilities';

import { getCDNAssetURL } from '../utils/web-helper';
const cdnAssetUrl = getCDNAssetURL();


export const GRADE_SUBJECT_CONTENT_LIST = [
  {
    "grade_id": 7,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Counting": "/math/counting-games-for-preschoolers",
      "Shapes": "/math/shapes-games-for-preschoolers",
      "Addition": "/math/addition-games-for-preschoolers"
    },
    "seeAll": {text: "See all 157 games", url: "/math-games-for-preschoolers"}
  },
  {
    "grade_id": 7,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Letter Names": "/ela/letter-names-games-for-preschoolers",
      "Letter Sequence": "/ela/letter-sequence-games-for-preschoolers",
      "Letter Tracing": "/ela/letter-tracing-games-for-preschoolers"
    },
    "seeAll": {text: "See all 463 games", url: "/ela-games-for-preschoolers"}
  },
  {
    "grade_id": 7,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Letter Names": "/ela/letter-names-worksheets-for-preschoolers",
      "Letter Sequence": "/ela/letter-sequence-worksheets-for-preschoolers",
      "Letter Tracing": "/ela/letter-tracing-worksheets-for-preschoolers"
    },
    "seeAll": {text: "See all 167 worksheets", url: "/ela-worksheets-for-preschoolers"}
  },
  {
    "grade_id": 1,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Number sense": "/math/number-sense-games-for-kindergarteners",
      "Addition": "/math/addition-games-for-kindergarteners",
      "Geometry": "/math/geometry-games-for-kindergarteners"
    },
    "seeAll": {text: "See all 314 games", url: "/math-games-for-kindergarteners"}
  },
  {
    "grade_id": 1,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Number Sense": "/math/number-sense-worksheets-for-kindergarteners",
      "Addition": "/math/addition-worksheets-for-kindergarteners",
      "Geometry": "/math/geometry-worksheets-for-kindergarteners"
    },
    "seeAll": {text: "See all 438 worksheets", url: "/math-worksheets-for-kindergarteners"}
  },
  {
    "grade_id": 1,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Letter Sounds": "/ela/letter-sounds-games-for-kindergarteners",
      "Letters A-Z": "/ela/letters-a-z-games-for-kindergarteners",
      "Reading Words": "/ela/reading-words-games-for-kindergarteners"
    },
    "seeAll": {text: "See all 1055 games", url: "/ela-games-for-kindergarteners"}
  },
  {
    "grade_id": 1,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Letter Sounds": "/ela/letter-sounds-worksheets-for-kindergarteners",
      "Letters A-Z": "/ela/letters-a-z-worksheets-for-kindergarteners",
      "Reading Words": "/ela/reading-words-worksheets-for-kindergarteners"
    },
    "seeAll": {text: "See all 438 worksheets", url: "/ela-worksheets-for-kindergarteners"}
  },
  {
    "grade_id": 2,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Additon": "/math/addition-games-for-1st-graders",
      "Subtraction": "/math/subtraction-games-for-1st-graders",
      "Time": "/math/time-games-for-1st-graders"
    },
    "seeAll": {text: "See all 352 games", url: "/math-games-for-1st-graders"}
  },
  {
    "grade_id": 2,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Addition": "/math/addition-worksheets-for-1st-graders",
      "Subtraction": "/math/subtraction-worksheets-for-1st-graders",
      "Time": "/math/time-worksheets-for-1st-graders"
    },
    "seeAll": {text: "See all 693 worksheets", url: "/math-worksheets-for-1st-graders"}
  },
  {
    "grade_id": 2,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Reading Words": "/ela/reading-words-games-for-1st-graders",
      "Sight Words": "/ela/sight-words-games-for-1st-graders",
      "Writing": "/ela/writing-games-for-1st-graders"
    },
    "seeAll": {text: "See all 613 games", url: "/ela-games-for-1st-graders"}
  },
  {
    "grade_id": 2,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Reading Words": "/ela/reading-words-worksheets-for-1st-graders",
      "Sight Words": "/ela/sight-words-worksheets-for-1st-graders",
      "Rhyming Words": "/ela/rhyming-words-worksheets-for-1st-graders"
    },
    "seeAll": {text: "See all 338 worksheets", url: "/ela-worksheets-for-1st-graders"}
  },
  {
    "grade_id": 3,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Addition": "/math/addition-games-for-2nd-graders",
      "Subtraction": "/math/subtraction-games-for-2nd-graders",
      "Counting Money": "/math/counting-money-games-for-2nd-graders"
    },
    "seeAll": {text: "See all 359 games", url: "/math-games-for-2nd-graders"}
  },
  {
    "grade_id": 3,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Addition": "/math/addition-worksheets-for-2nd-graders",
      "Subtraction": "/math/subtraction-worksheets-for-2nd-graders",
      "Counting Money": "/math/counting-money-worksheets-for-2nd-graders"
    },
    "seeAll": {text: "See all 825 worksheets", url: "/math-worksheets-for-2nd-graders"}
  },
  {
    "grade_id": 3,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Reading Words": "/ela/reading-words-games-for-2nd-graders",
      "Rhyming Words": "/ela/rhyming-words-games-for-2nd-graders",
      "Sight Words": "/ela/sight-words-games-for-2nd-graders"
    },
    "seeAll": {text: "See all 405 games", url: "/ela-games-for-2nd-graders"}
  },
  {
    "grade_id": 3,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Reading Words": "/ela/reading-words-worksheets-for-2nd-graders",
      "Diphthongs": "/ela/diphthongs-worksheets-for-2nd-graders",
      "Sight Words": "/ela/sight-words-worksheets-for-2nd-graders"
    },
    "seeAll": {text: "See all 222 worksheets", url: "/ela-worksheets-for-2nd-graders"}
  },
  {
    "grade_id": 4,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Multiplication": "/math/multiplication-games-for-3rd-graders",
      "Division": "/math/division-games-for-3rd-graders",
      "Fractions": "/math/fractions-games-for-3rd-graders"
    },
    "seeAll": {text: "See all 527 games", url: "/math-games-for-3rd-graders"}
  },
  {
    "grade_id": 4,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Multiplication": "/math/multiplication-worksheets-for-3rd-graders",
      "Division": "/math/division-worksheets-for-3rd-graders",
      "Fractions": "/math/fractions-worksheets-for-3rd-graders"
    },
    "seeAll": {text: "See all 742 worksheets", url: "/math-worksheets-for-3rd-graders"}
  },
  {
    "grade_id": 4,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Reading Skills": "/ela/reading-skills-games-for-3rd-graders",
      "Sequencing": "/ela/sequencing-games-for-3rd-graders",
      "Cause and Effect": "/ela/cause-and-effect-games-for-3rd-graders"
    },
    "seeAll": {text: "See all 44 games", url: "/ela-games-for-3rd-graders"}
  },
  {
    "grade_id": 4,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Nouns and Pronouns": "/ela/nouns-and-pronouns-worksheets-for-3rd-graders",
      "Compound Words": "/ela/compound-words-worksheets-for-3rd-graders",
      "Verbs and Tenses": "/ela/verbs-and-tenses-worksheets-for-3rd-graders"
    },
    "seeAll": {text: "See all 64 games", url: "/ela-worksheets-for-3rd-graders"}
  },
  {
    "grade_id": 5,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Multiplication": "/math/multiplication-games-for-4th-graders",
      "Decimals": "/math/decimals-games-for-4th-graders",
      "Fractions": "/math/fractions-games-for-4th-graders"
    },
    "seeAll": {text: "See all 351 games", url: "/math-games-for-4th-graders"}
  },
  {
    "grade_id": 5,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Multiplication": "/math/multiplication-worksheets-for-4th-graders",
      "Decimals": "/math/decimals-worksheets-for-4th-graders",
      "Fractions": "/math/fractions-worksheets-for-4th-graders"
    },
    "seeAll": {text: "See all 987 worksheets", url: "/math-worksheets-for-4th-graders"}
  },
  {
    "grade_id": 5,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Reading Skills": "/ela/reading-skills-games-for-4th-graders",
      "Prediction": "/ela/prediction-games-for-4th-graders",
      "Inference": "/ela/inference-games-for-4th-graders"
    },
    "seeAll": {text: "See all 44 games", url: "/ela-games-for-4th-graders"}
  },
  {
    "grade_id": 5,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Prepositions and Conjunctions": "/ela/prepositions-and-conjunctions-worksheets-for-4th-graders",
      "Punctuation": "/ela/punctuation-worksheets-for-4th-graders",
      "Affixes": "/ela/affixes-worksheets-for-4th-graders"
    },
    "seeAll": {text: "See all 72 games", url: "/ela-worksheets-for-4th-graders"}
  },
  {
    "grade_id": 6,
    "subject_id": 1,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Fractions": "/math/fractions-games-for-5th-graders",
      "Decimals": "/math/decimals-games-for-5th-graders",
      "Algebra": "/math/algebra-games-for-5th-graders"
    },
    "seeAll": {text: "See all 202 games", url: "/math-games-for-5th-graders"}
  },
  {
    "grade_id": 6,
    "subject_id": 1,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Fractions": "/math/fractions-worksheets-for-5th-graders",
      "Decimals": "/math/decimals-worksheets-for-5th-graders",
      "Algebra": "/math/algebra-worksheets-for-5th-graders"
    },
    "seeAll": {text: "See all 1843 worksheets", url: "/math-worksheets-for-5th-graders"}
  },
  {
    "grade_id": 6,
    "subject_id": 2,
    "content_type": 1, "content_title": "Games",
    "topics": {
      "Reading Skills": "/ela/reading-skills-games-for-5th-graders",
      "Prediction": "/ela/prediction-games-for-5th-graders",
      "Inference": "/ela/inference-games-for-5th-graders"
    },
    "seeAll": {text: "See all 44 games", url: "/ela-games-for-5th-graders"}
  },
  {
    "grade_id": 6,
    "subject_id": 2,
    "content_type": 2, "content_title": "Worksheets",
    "topics": {
      "Verbs and Tenses": "/ela/verbs-and-tenses-worksheets-for-5th-graders",
      "Sentences": "/ela/sentences-worksheets-for-5th-graders",
      "Figures of Speech": "/ela/figures-of-speech-worksheets-for-5th-graders"
    },
    "seeAll": {text: "See all 53 games", url: "/ela-worksheets-for-5th-graders"}
  }
];


export const ContentTypeList = {
  1: {
    id: 1,
    code: "games",
    title: "Games",
    count: "(4413+)",
    imgDirPath: `${cdnAssetUrl}/web_ui/assets/images/loggedout/Curriculum-images/Playable`
  },
  2: {
    id: 2,
    code: "worksheets",
    title: "Worksheets",
    count: "(4567+)",
    imgDirPath: `${cdnAssetUrl}/web_ui/assets/images/loggedout/Curriculum-images/Worksheet`
  }
};

export const gradeList = [
  {
      "id": 7,
      "code": "pk",
      "title": "Pre-Kindergarten",
      "ordering": 4
  },
  {
      "id": 1,
      "code": "k",
      "title": "Kindergarten",
      "ordering": 5
  },
  {
      "id": 2,
      "code": 1,
      "title": "Grade 1",
      "ordering": 6
  },
  {
      "id": 3,
      "code": 2,
      "title": "Grade 2",
      "ordering": 7
  },
  {
      "id": 4,
      "code": 3,
      "title": "Grade 3",
      "ordering": 8
  },
  {
      "id": 5,
      "code": 4,
      "title": "Grade 4",
      "ordering": 9
  },
  {
      "id": 6,
      "code": 5,
      "title": "Grade 5",
      "ordering": 10
  }
];

export const subjectList = {
  1: {
    "id": 1,
    "code": "math",
    "title": "Math",
    "imageDir": "Math-images",
  },
  2: {
    "id": 2,
    "code": "ela",
    "title": "Reading",
    "imageDir": "ELA-images",
  }
};

export const getGradeImage = (content_type, subject_id, gradeCode ) => {
  const imagePath = `${ContentTypeList[content_type].imgDirPath}/${subjectList[subject_id].imageDir}`

  return {
    src: `${imagePath}/${gradeCode}.png`,
    srcset: `${imagePath}/${gradeCode}.png 374w,
              ${imagePath}/${gradeCode}_2x.png 748w`,
    sizes: `${device.Phone} 374px,
            ${device.Tablet} 374px,
            ${device.Desktop} 748px,
            374px`
  }
}
